import * as React from 'react';

/** True inside an open Drawer, so a Modal opened from it can stack above it. */
export const InsideDrawerContext = React.createContext(false);
